import Immutable from 'immutable';
import { handleActions } from 'redux-actions';

const AddMaintenanceCaseState = Immutable.fromJS({
  mCaseRequestModel: {
    customerId: '',
    customerName: '',
    orderId: '',
    prefix: '',
    note: '',
    init: '',
    org: '',
    unit: '',
    receivedDate: '',
    returnDate: ''
  },

  mCaseViewModel: {
    mOrderIds: [],
  },

  alert: {
    style: null,
    message: null
  }
});

const addMaintenanceCaseReducer = handleActions({
  SET_MAINTAIN_CASE_REQ_PARAM: (state, { payload }) => {
    let modelObject = state.get('mCaseRequestModel');
    return state.merge({
      mCaseRequestModel: modelObject.set(payload.param, payload.value),
    })
  },

  DISPLAY_MAINTENANCE_CASE_UPLOADING: (state, { payload }) => {
    return state.merge({
      alert: {
        style: 'info',
        message: '資料處理中，請稍後。'
      }
    })
  },

  COMPLETE_UPLOAD_MAINTENANCE_CASE_DATA: (state, { payload }) => {
    return state.merge({
      alert: {
        style: payload.alertStyle,
        message: payload.displayMessage
      }
    })
  },

  ALERT_MAINTENENCE_CASE_MESSAGE: (state, { payload }) => {
    return state.merge({
      alert: {
        style: 'warning',
        message: payload
      }
    })
  },

  ALERT_MAINTENENCE_CASE_REQUIRED_FIELDS: (state, { payload }) => {
    return state.merge({
      alert: {
        style: 'warning',
        message: '訂單編號, 註記 與使用者清單為必填欄位'
      }
    })
  },

  CLEAR_MAINTENANCE_PAGE_STATE: (state, { payload }) => {
    return state.merge({
      mCaseRequestModel: {
        customerId: '',
        customerName: '',
        orderId: '',
        prefix: '',
        note: '',
        init: '',
        org: '',
        unit: '',
        receivedDate: '',
        returnDate: ''
      },
      alert: {
        style: null,
        message: null
      }
    })
  },

  CLEAN_ADD_CASE_ALERT: (state, { payload }) => {
    return state.merge({
      alert: {
        style: null,
        message: null
      }
    })
  }

}, AddMaintenanceCaseState);

export default addMaintenanceCaseReducer;


// WEBPACK FOOTER //
// ./src/reducers/addMaintenanceCaseReducer.js